import { render, staticRenderFns } from "./detailCardAgent.vue?vue&type=template&id=16aaafe6&scoped=true"
import script from "./detailCardAgent.vue?vue&type=script&lang=js"
export * from "./detailCardAgent.vue?vue&type=script&lang=js"
import style0 from "./detailCardAgent.vue?vue&type=style&index=0&id=16aaafe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aaafe6",
  null
  
)

export default component.exports